<template>
  <v-dialog v-model="model" max-width="400">
    <template #activator="{ on }">
      <slot name="activator" :on="on">
        <v-btn color="pink" class="white--text" depressed v-on="on">
          Add folder
          <v-icon right> mdi-folder-plus </v-icon>
        </v-btn>
      </slot>
    </template>
    <v-card>
      <v-card-title class="pink--text"> Create Folder </v-card-title>
      <v-card-text>
        <v-form ref="form" @submit.prevent="onSubmit">
          <v-text-field v-model="crud.name" label="Name" :rules="[rules.required]" clearable />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="pink"
          :loading="loading"
          depressed
          class="ml-auto white--text"
          @click="onSubmit"
        >
          Create
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { rules } from "../../mixins/rulesMixin";
import { createFolder } from "@/api/api";

export default {
  props: {
    extraBody: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      rules,
      crud: {
        name: "",
      },
      loading: false,
      model: false,
    };
  },
  methods: {
    async onSubmit() {
      const form = this.$refs.form;
      if (!form.validate()) return;
      this.loading = true;
      try {
        const { data } = await createFolder({
          ...this.crud,
          folder: (this.$route.params.path || "").split("&").at(-1) || null,
          level: this.$route.params.level__uuid === "null" ? null : this.$route.params.level__uuid,
          ...this.extraBody,
        });
        this.$emit("new-folder", {
          name: data.name,
          uuid: data.uuid,
          type: "FOLDER",
        });
        this.model = false;
        form.reset();
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
